import React from 'react';
import PageSnackbars from '../common/PageSnackbars';
import { usePageSnackbar } from '../common/usePageSnackbar';
import CampaignListDashboard from '../common/CampaignListDashboard';
import SMSAnalyticsDialog from '../SMSAnalyticsDialog';
import { useCampaignListDashboard } from '../../hooks/useCampaignListDashboard';

const SMSDashboard = ({ embedded = false }) => {
  const snackbar = usePageSnackbar();
  const list = useCampaignListDashboard('sms', snackbar);

  return (
    <CampaignListDashboard
      list={list}
      embedded={embedded}
      AnalyticsDialog={SMSAnalyticsDialog}
      PageSnackbars={PageSnackbars}
      snackbarProps={snackbar.snackbarProps}
    />
  );
};

export default SMSDashboard;
